import React from "react";
import {connect} from "react-redux";
import {subscribe, fieldUpdated} from "./actions";
import {DeliveryForm} from './styles';

const validatePhoneNumber = (phone) => {
  const phoneRegex = /^\+[1-9]\d{8,14}$/; // Простая проверка международного номера
  return phoneRegex.test(phone);
};

const Component = ({subscribed, processing, data, title, qty, count, onSubmit, onChange, deliveryDisabled}) => {

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validatePhoneNumber(data.phone)) {
      alert('Введите корректный номер телефона с кодом страны (+7…)');
      return;
    }
    onSubmit(data);
  };

    if (subscribed.delivery) return (
        <p>Спасибо за подписку. На Ваш email было отправлено письмо с подтверждением.</p>
    );

  return (
    <div style={{ textAlign: 'center' }}>
      <h2>Подпишитесь на рассылку «{title}»</h2>
      <p>и получите промокод и доступ к наборам лексики уроков в приложении для заучивания слов и
        фраз MemoWord!</p>
      <DeliveryForm className="form-inline" onSubmit={handleSubmit}>
        <div className="form-group my-1">
          <input type="text" className="form-control form-control-lg"
                 value={data.name} onChange={e => onChange('name', e.target.value)}
                 placeholder="Ваше имя"/>
        </div>
        &nbsp;
        <div className="form-group my-1">
          <input type="email" className="form-control form-control-lg"
                 disabled={deliveryDisabled}
                 value={data.email} onChange={e => onChange('email', e.target.value)}
                 placeholder="Ваш email"/>
        </div>
        &nbsp;
        <div className="form-group my-1">
          <input type="phone" className="form-control form-control-lg"
                 disabled={deliveryDisabled}
                 value={data.phone} onChange={e => onChange('phone', e.target.value)}
                 placeholder="Телефон с кодом страны (+7…)"/>
        </div>
        &nbsp;
        <button type="submit"
                disabled={processing || !data.name || !data.email || !data.phone}
                className="btn btn-warning btn-lg my-1">Подписаться
        </button>
      </DeliveryForm>

      {count > 100 ?
        <div className="text-center my-2" dangerouslySetInnerHTML={{ __html: qty }}/>
        : null}
    </div>
  );
};

const Form = connect(
    state => ({
        deliveryDisabled: deliveryDisabled,
        title: deliveryTitle,
        qty: deliveryQty,
        count: deliveryCount,
        data: state.deliveryForm.data,
        processing: state.deliveryForm.processing,
        subscribed: state.deliveryForm.subscribed
    }),
    dispatch => ({
        onSubmit: data => dispatch(subscribe(data)),
        onChange: (field, value) => dispatch(fieldUpdated(field, value))
    })
)(Component);

export default Form;



// WEBPACK FOOTER //
// ./src/delivery/container.js